import { AnyAction } from 'redux';
import { DropdownOption } from '../../components/shared/TailwindComponents/Dropdown';

interface DropdownState {
  dropdowns: { [key: string]: DropdownOption[] };
}

const initialState: DropdownState = {
  dropdowns: {
    aiVoices: [],
    aiFontSizes: [],
    aiJurisdictions: [],
    aiLanguages: [],
    businesses: [],
    caseStatuses: [],
    caseTypes: [],
    desiredOutcomes: [],
    expectedOutcomes: [],
    lawfirmRoles: [],
    legalSubjects: [],
    platformCurrencies: [],
    platformLanguages: [],
    practiceAreas: [],
    preferredLanguages: [],
    urgencyStatus: [],
    projectStatus: [],
    priority: [],
    projectCategory: [],
    lawfirmDepartments: [],
    businessDepartments: [],
    employeeRoles: [],
    caseStages: [],
    caseProcess: [],
    caseProcessStatuses: [],
    matterTypes: [],
    matterStatuses: [],
    matterClientRoles: [],
    collaboratorRoles:[],
  }
};

const dropdownReducer = (state = initialState, action: AnyAction): DropdownState => {
  switch (action.type) {
    case 'SET_DROPDOWN_DATA':
      return {
        ...state,
        dropdowns: {
          ...state.dropdowns,
          [action.payload.dropdownKey]: action.payload.data
        }
      };
    default:
      return state;
  }
};

export default dropdownReducer;